function loadImg(src) {
  const i = new Image()
  i.src = src
  return i
}

function requireAll(obj) {
  Object.values(obj).forEach(loadImg)
  return obj
}

/* eslint-disable global-require */
export default requireAll({
  // Home page pictures
  homeHero: require('@/assets/rings.jpg'),
  engaged: require('@/assets/home/home_hero.jpg'),
  home2: require('@/assets/home/home_2.jpg'),
  camping: require('@/assets/home/camping.jpg'),
  rock: require('@/assets/home/under_a_rock.jpg'),
  graduation: require('@/assets/home/graduation.jpg'),
  homeStives: require('@/assets/home/st_ives.jpg'),
  gsWedding: require('@/assets/home/gs_wedding.jpg'),
  snowLove: require('@/assets/home/snow_love.jpg'),
  marietteSmile: require('@/assets/home/beautiful.jpg'),

  // Area page pictures
  cornwall: require('@/assets/gorse.png'),
  eden: require('@/assets/eden.jpg'),
  tintagel: require('@/assets/tintagel.jpg'),
  stives: require('@/assets/stives.jpg'),
  mousehole: require('@/assets/mousehole.jpg'),
  botallack: require('@/assets/botallack.jpg'),
  heligan: require('@/assets/heligan.jpg'),

  // Wedding page pictures
  wedding: require('@/assets/ceremony.jpg'),
  confetti: require('@/assets/confetti.jpg'),
  simonsig: require('@/assets/simonsig.jpg'),
  reception: require('@/assets/decor.jpg'),
  house: require('@/assets/house.jpg'),
})
/* eslint-enable global-require */
